import type { Graph, Thing, WithContext } from 'schema-dts';

export interface LinkedDataJsonProps<T extends Thing> {
  id: string;
  schema: WithContext<T> | Graph;
}

export function LinkedDataJson<T extends Thing>({ id, schema }: LinkedDataJsonProps<T>) {
  return (
    <script
      id={id}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      key={id}
    />
  );
}
